const module = { name: 'video/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as jwplayer } from 'swug-fdRequire-call:video/jwplayer';



import { default as freewheel } from 'swug-fdRequire-call:video/jwplayer/freewheel';

function run() {
    checkDependencies(module.name, debugLog);
    freewheel.init(jwplayer.init);
}
document.addEventListener('DOMContentLoaded', run);
export default module.exports;